module.exports = {
  config: {
    apiUrl:
      "https://cklniesn87.execute-api.eu-central-1.amazonaws.com/prod/front",
    //apiUrl: "https://b6gf0a80la.execute-api.eu-central-1.amazonaws.com/prod/front",
    s3Url: "https://s3-eu-central-1.amazonaws.com/org.poslodavacpartner.data",
  },
};
